/*
 * Where: src/pages/ReadPage.js
 * What: Read page component (read.html route).
 * Why: Host the card reading status section in a dedicated page.
 */
import React from 'react';
import { READ_HERO } from '../constants/readPageContent';
import ReadingStatusSection from '../features/top/components/ReadingStatusSection';
import ServiceHeroSection from '../features/top/components/ServiceHeroSection';
import { useReadingStatus } from '../hooks/useReadingStatus';

function ReadPage() {
    const {
        statusCopy,
        primaryLabel,
        lastReadUid,
        lastReadSource,
        citizenSupport,
        canShowSupportList,
        readError,
        isLoading,
        isPrimaryDisabled,
        canCompleteForDevelopment,
        startReading,
        completeReadingForDevelopment,
    } = useReadingStatus();

    return (
        <>
            <ServiceHeroSection hero={READ_HERO} />
            <ReadingStatusSection
                statusCopy={statusCopy}
                primaryLabel={primaryLabel}
                lastReadUid={lastReadUid}
                lastReadSource={lastReadSource}
                citizenSupport={citizenSupport}
                canShowSupportList={canShowSupportList}
                readError={readError}
                isLoading={isLoading}
                isPrimaryDisabled={isPrimaryDisabled}
                canCompleteForDevelopment={canCompleteForDevelopment}
                onStartReading={startReading}
                onCompleteForDevelopment={completeReadingForDevelopment}
            />
        </>
    );
}

export default ReadPage;
